import {Pipe, PipeTransform} from '@angular/core';
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

@Pipe({
    name: 'timeLimit',
    standalone: false
})
export class TimeLimitPipe implements PipeTransform {

  transform(startDate?: Date, endDate?: Date): string {
    var timeLimit: number | undefined;
    var timeLimitString: string | undefined;

    if (startDate && endDate) {
      timeLimit = this.calculateTimeLimit(startDate, endDate);
    }
    if (timeLimit === undefined || timeLimit === 0) {
      timeLimitString = '-';
    } else {
      timeLimitString = dayjs.duration(timeLimit, 'minutes').format('HH:mm');
    }

    return timeLimitString;
  }

  private calculateTimeLimit(startDate: Date, endDate: Date): number {
    return dayjs(endDate).diff(dayjs(startDate), 'minutes');
  }
}
